abstract class AbstractTranslatorResourceLoader {
    abstract load: (
        path: string,
    ) => Promise<unknown>
}

export {
    AbstractTranslatorResourceLoader
}
